module.exports = __webpack_public_path__ + "img/Frame_44.b365f4e6.png";